import { render, staticRenderFns } from "./thirdStep.vue?vue&type=template&id=1a279893"
import script from "./thirdStep.vue?vue&type=script&lang=ts"
export * from "./thirdStep.vue?vue&type=script&lang=ts"
import style0 from "./thirdStep.vue?vue&type=style&index=0&id=1a279893&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports